import { Atom, atom } from 'jotai'
import { parcelsClient, zoneClient } from 'src/clients'
import { ZoneDetailResponse } from 'src/common-services/types/zone-types'
import { atomFamily } from 'src/utils/jotai'

export const zoningByCoordinates = atomFamily<
  { lat: number; lng: number },
  Atom<Promise<{ mCode: string; zoneDetails: ZoneDetailResponse }>>
>(({ lat, lng }) =>
  atom(async () => {
    const [{ mCode }, zoneDetails] = await Promise.all([
      parcelsClient.getMCodeByLatLng({ lat, lng }),
      zoneClient.getDetailByLocation(lat, lng),
    ])

    return { mCode, zoneDetails }
  })
)
